import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { GetProfileById } from './get-profile-by-id.thunk';

interface ReorderPracticeProfileImagesRequest {
    profileId: string;
    practiceProfileId: string;
    locationId: string;
    uploadIdsInOrder: number[];
}

export const ReorderPracticeProfileImages = createAsyncThunk(
    'profilesData/reorderPracticeProfileImages',
    async (
        request: ReorderPracticeProfileImagesRequest,
        { getState, dispatch }: any
    ) => {
        const axios = getState().core.axios;
        const { profileId, practiceProfileId, locationId, uploadIdsInOrder } =
            request;

        const response = await axios.put(
            `api/ProfilesData/PracticeProfileUploads/${profileId}/${practiceProfileId}/order`,
            { locationId, uploadIdsInOrder }
        );

        if (response.status !== 200) {
            createNotification(
                'Could not save the image order. Please try again.',
                'error'
            );
        }
        await dispatch(GetProfileById(profileId));
    }
);
